import 'whatwg-fetch';
import React from 'react';

import { createRoot } from 'react-dom/client';
import { Provider as ReduxProvider } from 'react-redux';

import { initApm } from 'services/initApm';
import { initSentry } from 'services/initSentry';
import configureStore from 'store/configureStore';
import connectStoreToAxiosInterceptors from 'utils/connectStoreToAxiosInterceptors';

const store = configureStore({});
const container = document.getElementById('schoolinks-app');
initSentry();
initApm();

connectStoreToAxiosInterceptors(store);

const main = () => {
  const App = require('components/App').default; // eslint-disable-line global-require
  const root = createRoot(container);
  root.render(
    <ReduxProvider store={store}>
      <App store={store} />
    </ReduxProvider>,
  );
};

export default main;
